import React, { useState } from 'react';
import './SearchBar.css';

const SearchBar = ({ searchParams, setSearchParams, setIsInitialLoad, isCompactMode = false, areFiltersExpanded = false, setAreFiltersExpanded = () => {} }) => {
  const [searchTerm, setSearchTerm] = useState(searchParams.term || '');
  const [searchAbbr, setSearchAbbr] = useState(searchParams.abbr || '');
  const [searchNumber, setSearchNumber] = useState(searchParams.number || '');

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleAbbrChange = (e) => {
    setSearchAbbr(e.target.value);
  };

  const handleNumberChange = (e) => {
    setSearchNumber(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setIsInitialLoad(false);

    // Close the custom buylist section when performing a search
    const altCart = document.querySelector('.alt-cart');
    if (altCart) {
      const customItemsEvent = new CustomEvent('closeCustomItems');
      altCart.dispatchEvent(customItemsEvent);
    }

    // Pass the raw number to backend - let backend handle special formats like "041/182" or "swsh10"
    const rawNumber = searchNumber ? searchNumber.trim() : '';

    setSearchParams(prev => ({
      ...prev,
      term: searchTerm,
      abbr: searchAbbr.toLowerCase(),
      number: rawNumber,
      page: 1
    }));
  };

  // In compact mode, show name search always visible with collapsible extra fields
  if (isCompactMode) {
    return (
      <div className="alt-search-section alt-search-section-compact">
        <form onSubmit={handleSearchSubmit} className="alt-search-form">
          {/* Always visible: Name search + Search button */}
          <div className="alt-search-inputs-primary">
            <input
              type="text"
              placeholder="Search by Name"
              className="alt-search-input"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <div className="alt-search-buttons-row">
              <button type="submit" className="alt-search-button">Search</button>
              <button
                type="button"
                className={`alt-filters-toggle-button ${areFiltersExpanded ? 'expanded' : ''}`}
                onClick={() => setAreFiltersExpanded(!areFiltersExpanded)}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M3 4h18M3 12h18M3 20h18"/>
                  <circle cx="8" cy="4" r="2" fill="currentColor"/>
                  <circle cx="16" cy="12" r="2" fill="currentColor"/>
                  <circle cx="10" cy="20" r="2" fill="currentColor"/>
                </svg>
                <span>Filters</span>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  className={`alt-filters-chevron ${areFiltersExpanded ? 'expanded' : ''}`}
                >
                  <path d="M6 9l6 6 6-6"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Collapsible: Abbreviation, Number inputs */}
          <div className={`alt-search-inputs-secondary ${areFiltersExpanded ? 'expanded' : ''}`}>
            <input
              type="text"
              placeholder="Search by Abbreviation"
              className="alt-search-input"
              value={searchAbbr}
              onChange={handleAbbrChange}
            />
            <input
              type="text"
              placeholder="Search by Number (e.g., 041/182)"
              className="alt-search-input"
              value={searchNumber}
              onChange={handleNumberChange}
            />
          </div>
        </form>
      </div>
    );
  }

  // Standard mode - all inputs visible
  return (
    <div className="alt-search-section">
      <form onSubmit={handleSearchSubmit} className="alt-search-form">
        <div className="alt-search-inputs">
          <input
            type="text"
            placeholder="Search by Name"
            className="alt-search-input"
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <input
            type="text"
            placeholder="Search by Abbreviation"
            className="alt-search-input"
            value={searchAbbr}
            onChange={handleAbbrChange}
          />
          <input
            type="text"
            placeholder="Search by Number (e.g., 041/182, swsh10)"
            className="alt-search-input"
            value={searchNumber}
            onChange={handleNumberChange}
          />
          <button type="submit" className="alt-search-button">Search</button>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
